export const getInitials = (nameString: string): string => {
    const fullName = nameString?.split(' ')

    if (fullName?.length === 1) {
        return fullName[0].charAt(0).toUpperCase()
    }

    const initials = fullName?.shift()?.charAt(0) + fullName?.pop()?.charAt(0)
    return initials.toUpperCase()
}
